export default __webpack_public_path__ + "static/case-study-after-f5afe2b4d2a2776a05ec519120a9d79d.png";